module.exports = __webpack_public_path__ + "img/enter-black.d378ba45.svg";